import { Wifi, WifiOff, Loader2 } from "lucide-react";
import { useRealtimeStatus } from "@/hooks/useRealtimeStatus";

export default function RealtimeStatusIndicator() {
  const { isConnected, isChecking } = useRealtimeStatus();

  if (isChecking) {
    return (
      <div className="flex items-center gap-1 text-xs text-gray-500">
        <Loader2 className="w-3 h-3 animate-spin" />
        <span>Verificando conexión...</span>
      </div>
    );
  }

  if (isConnected === null) {
    return null;
  }

  return (
    <div className="flex items-center gap-1 text-xs">
      {isConnected ? (
        <>
          <Wifi className="w-3 h-3 text-green-500" />
          <span className="text-green-600">Tiempo real activo</span>
        </>
      ) : (
        <>
          <WifiOff className="w-3 h-3 text-red-500" />
          <span className="text-red-600">Sin conexión en tiempo real</span>
        </>
      )}
    </div>
  );
}
